import styled, { css } from "styled-components";
import { palette } from "styled-tools";
import {
  ButtonBaseProps,
  ButtonSize,
  buttonStyleBySize,
  txtColorByButtonColor,
} from "./interface";
import { ThemeColor } from "styles/theme";
import { ButtonIconPosition } from "components/Atoms//Button/IconButtonLayout";

export const ButtonContentContainer = styled.div<{
  iconPosition?: ButtonIconPosition;
}>`
  display: flex;
  align-items: center;
  flex-direction: ${({ iconPosition }) =>
    iconPosition === ButtonIconPosition.LEFT ? "row" : "row-reverse"};
`;

const ButtonCommonStyle = css`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${palette(ThemeColor.JBLACK)};
  border: 1px solid rgba(181, 184, 194, 1);

  &:not(:disabled):not(.disabled) {
    cursor: pointer;
  }

  &.disabled {
    cursor: not-allowed;
  }

  > * {
    cursor: pointer;
  }
`;

export const Button = styled.button<ButtonBaseProps>`
  ${() => ButtonCommonStyle}

  width: ${(props) => (props.fillWidth ? "100%" : "inherit")};
  ${(props) => buttonStyleBySize[props.size || ButtonSize.MEDIUM]};

  ${(props) =>
    props.primary &&
    css`
      border: 1px solid ${palette("primary")};
      color: ${palette("primary")};
      font-weight: 600;
      border-radius: 6px;
      background-color: transparent;
    `}

  ${(props) =>
    props.secondary &&
    css`
      color: ${props.color ? palette(props.color) : palette("dgray")};
      border-radius: 6px;
      border: 1px solid ${palette("mgray")};
      font-weight: normal;
      background-color: transparent;
    `}

  ${(props) =>
    props.disabled &&
    css`
      background-color: #d7dae2;
      border-radius: 6px;
      font-weight: 600;
      color: white;
      border: none;
    `}

  ${(props) =>
    !props.disabled &&
    props.fillBackground &&
    css`
      background-color: ${props.backgroundColor
        ? palette(props.backgroundColor)
        : palette("primary")};
      color: white;
      border-color: transparent;
    `};

  color: ${(props) =>
    props.color
      ? palette(props.color)
      : palette(txtColorByButtonColor[props.backgroundColor as ThemeColor])};

  ${(props) =>
    props.backgroundColor &&
    css`
      background: ${palette(props.backgroundColor, props.tone)};
      border-color: transparent;
    `}

  border-radius: ${(props) => props.rounding && `${props.rounding}px`};
  text-align: center;
  font-weight: ${(props) => (props.bold ? 600 : "normal")};
  border-color: ${(props) => props.borderColor && palette(props.borderColor)};
  border: ${(props) => props.border && props.border};
  @media (hover: hover) {
    &:hover {
      box-shadow: inset 0 0 0 50px rgba(28, 28, 30, 0.07);
    }
  }

  &:active {
    box-shadow: inset 0 0 0 50px rgba(28, 28, 30, 0.07);
  }
`;
